<template>
    <div class="modal-container">

        <button @click="open" class="link">Quick View<i class="fa fa-expand icon" aria-hidden="true"></i></button>

        <div class="remodal" :data-remodal-id='modalID'>
            <div class="modal">
                <div class="product">
                    <header>
                        <h2>
                            <span v-text="item.brand"></span>
                            <a :href="item.uri" v-text="item.title"></a>
                        </h2>
                        <div v-if="item.detailImage" class="product-image">
                            <img :src="item.detailImage"  :alt="item.title">
                        </div>
                    </header>
                    <div class="wrapper">
                        <div>
                            <div v-html="item.description"></div>
                        </div>

                        <submittal-widget
                            :id="item.objectID"
                            :user="user"
                            :figure="item.figureNumber"
                            :title="item.title"
                            :has-submittal="item.hasSubmittal"
                            :brand="result.brand"
                            :submittal-file-url="submittalFileUrl"
                        />
                    </div>
                </div>
            </div>
            <button data-remodal-action="close" class="remodal-close simple"></button>
        </div>
    </div>
</template>

<script>
    import Modal from 'vue/common/_modal';

    export default {
        extends: Modal,
        props: ['result', 'user'],
        computed: {
            submittalFileUrl() {
                return null;
            },
        }
    }
</script>